<template>
  <div :ref="reference" class="bg-video" :style="{ 'background-color': background }">
    <!-- :style="styles" -->
    <video ref="videoEl" :preload="preload" :muted="muted ? true : false" :autoplay="autoplay ? true : false" :playsinline="autoplay ? true : false" :loop="loop ? true : false" class="video" :class="videoClass">
      <source ref="source" :src="src" type="video/mp4" />
    </video>

    <transition name="fade">
      <div v-if="poster && !playing" class="poster" :style="{ backgroundImage: 'url(' + poster + ')' }">
        <img :src="poster" @load="posterLoaded" style="display: none" alt="" />
      </div>
    </transition>

    <transition name="fade">
      <div v-if="loader && !loaded" class="video-loader"></div>
    </transition>

    <div v-if="overlay" class="overlay-video" :style="{ backgroundColor: overlay }"></div>

    <div v-if="pattern" class="overlay-pattern" :style="{ backgroundImage: `url(${pattern})` }"></div>

    <button v-if="!playing" type="button" class="btn-play" @click="playVideo()">
      <slot name="btnplay"></slot>
    </button>

    <button v-if="btns.fullscreen" type="button" class="video-full-btn" @click="playFullscreen($event)">
      <i class="icon-expand icon-l"></i>
    </button>

    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
      default: null,
    },
    videoClass: {
      type: String,
      required: false,
      default: null,
    },
    preload: {
      type: String,
      required: false,
      default: "metadata",
    },
    poster: {
      type: String,
      required: false,
      default: null,
    },
    loader: {
      type: Boolean,
      required: false,
      default: false,
    },
    background: {
      type: String,
      required: false,
      default: null,
    },
    muted: {
      type: Boolean,
      required: false,
      default: true,
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: true,
    },
    autoplayAfter: {
      type: Boolean,
      required: false,
      default: null,
    },
    loop: {
      type: Boolean,
      required: false,
      default: true,
    },
    speed: {
      type: Number,
      required: false,
      default: 1.0,
    },
    overlay: {
      type: String,
      required: false,
      default: null,
    },
    pattern: {
      type: String,
      required: false,
      default: null,
    },
    btns: {
      type: Object,
      required: false,
      default: function () {
        return {
          fullscreen: false,
        };
      },
    },
    reference: {
      type: String,
      required: false,
      default: "video-wrapper",
    },
  },
  data() {
    return {
      playing: false,
      loaded: false,
      fill: "width",
      videoWrapperSize: {},
      videoElSize: {},
    };
  },
  computed: {
    styles() {
      let styles = {};

      if (this.fill === "width") {
        styles = {
          width: "100%",
        };
      } else if (this.fill === "height") {
        styles = {
          height: "100%",
        };
      }

      return styles;
    },
    videoWrapperRatio() {
      return this.videoWrapperSize.width / this.videoWrapperSize.height;
    },
  },
  watch: {
    playing: function (val) {
      if (val) {
        this.$refs.videoEl.play();
      } else {
        this.$refs.videoEl.pause();
      }
    },
    autoplayAfter: function (val) {
      if (val) {
        this.playing = true;
      }
    },
    videoWrapperSize: function () {
      this.calcFill();
    },
  },
  methods: {
    playFullscreen(e) {
      var $video = this.$refs.videoEl;
      if ($video.requestFullScreen) {
        $video.requestFullScreen();
      } else if ($video.webkitRequestFullScreen) {
        $video.webkitRequestFullScreen();
      } else if ($video.mozRequestFullScreen) {
        $video.mozRequestFullScreen();
      }
      $video.play();
    },
    playVideo() {
      this.playing = true;
    },
    pauseVideo() {
      this.$refs.videoEl.pause();
    },
    loadVideo() {
      this.$refs.videoEl.load();
    },
    posterLoaded() {
      this.$emit("poster-loaded");
    },
    calcVideoWrapperSize() {
      this.videoWrapperSize = {
        width: this.$refs["video-wrapper"].offsetWidth,
        height: this.$refs["video-wrapper"].offsetHeight,
      };
    },
    calcVideoElSize() {
      this.videoElSize = {
        width: this.$refs["videoEl"].videoWidth,
        height: this.$refs["videoEl"].videoHeight,
        ratio:
          this.$refs["videoEl"].videoWidth / this.$refs["videoEl"].videoHeight,
      };
    },
    calcFill() {
      if (this.videoWrapperRatio > this.videoElSize.ratio) {
        this.fill = "width";
      } else {
        this.fill = "height";
      }
    },
    // inViewport() {
    //   const rect = this.$refs[this.reference].getBoundingClientRect();
    //   const html = document.documentElement;
    //   return (rect.top >= 0 && rect.top < html.clientHeight) || (rect.bottom >= 0 && rect.bottom < html.clientHeight);
    // }
  },
  created() {
    // window.addEventListener(
    //   "resize",
    //   () => {
    //     setTimeout(() => {
    //       this.calcVideoWrapperSize();
    //       this.calcFill();
    //     }, 100);
    //   },
    //   {
    //     passive: true,
    //   }
    // );

    // window.addEventListener("scroll", this.inViewport, { passive: true });
  },
  mounted() {
    this.$refs.videoEl.playbackRate = this.speed;

    this.$refs.videoEl.oncanplay = () => {
      this.$emit("can-play");
    };

    this.$refs.videoEl.oncanplaythrough = () => {
      this.$emit("can-play-through");
      this.loaded = true;
      if (this.autoplay) {
        this.playing = true;
      }
    };

    this.$refs.videoEl.onpause = () => {
      this.$emit("paused");
      // this.playing = false;
    };

    this.$refs.videoEl.onended = () => {
      this.$emit("ended");
    };

    this.$refs.videoEl.ontimeupdate = () => {
      this.$emit("time-update", this.$refs.videoEl);
    };

    this.$refs.videoEl.onloadeddata = (data) => {
      this.$emit("loaded-data");
    };

    this.$refs.videoEl.onloadedmetadata = (metadata) => {
      this.$emit("loaded-metadata");
      this.calcVideoElSize();
      this.calcVideoWrapperSize();
      this.calcFill();
    };
  },
  destroyed() {
    // window.removeEventListener("scroll", this.inViewport);
  },
};
</script>

<style lang="scss">
bg-video {
  display: block;
  position: relative;
}

.bg-video {
  display: block;
  overflow: hidden;
  width: 100%;
  position: relative;

  .video {
    min-width: 100%;
    min-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .poster {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: 50%;
  }

  .btn-play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .video-full-btn {
    position: absolute;
    bottom: 25%;
    right: 10%;
    color: #fff;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }

  .overlay-video {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .overlay-pattern {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 100%;
    opacity: 0.6;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  &.pos-top {
    .video {
      top: 0%;
      transform: translateX(-50%);
    }
  }
}

@media only screen and (max-width: 991px) {
  .bg-video {
    .video-full-btn {
      bottom: 5%;
    }
  }
}
</style>